import { outputObjectiveItems } from 'constants/InsightsGatheringConstants'

export const OutputObjective = () => (
  <div className="insights-output-box flex flex-col gap-4">
    <p className="subtitle-xl">Output - Objective:</p>
    <div className="flex gap-4 w-full">
      {outputObjectiveItems.map(item => (
        <div key={item.number} className="insights-output-card">
          <p className="body-xs">{item.text}</p>
          <span className={item.number === 1 ? 'insights-output-card-number-one' : 'insights-output-card-number'}>
            {item.number}
          </span>
        </div>
      ))}
    </div>
  </div>
)
